module.exports = __webpack_public_path__ + "img/profile-woman-6-min.e03fa5e7.jpg";